import Vue from "vue";
import Rsa from "./Rsa";
import globalConfig from "./globalConfig";
const rsa = new Rsa();
export const EventBus = new Vue();
// export const SUCEESSS_POPUP = "successPop";
// export const FAIL_GIFT_POPUP = "failGiftPop";
// export const FAIL_CHECK_POPUP = "failCheckPop";
export let convertParamToString = function(params) {
  var str = "?";
  var paramArray = [];
  for (var key in params) {
    var val = params[key];
    if ("object" === typeof val) {
      val = JSON.stringify(val);
    }
    var param = key + "=" + val;
    paramArray.push(param);
  }
  paramArray.push("callback");
  if (paramArray.length > 0) {
    return paramArray.join("&");
  }
  return "";
};

export function b64DecodeUnicode(str) {
  return decodeURIComponent(
    atob(str)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
}

export function b64EncodeUnicode(str) {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
      return String.fromCharCode("0x" + p1);
    })
  );
}

export const encryption = function(text) {
  //todo encryption the text
  return rsa.encode(text);
  // return text;
};

// 统计接口,config格式如下：
// {
//     id: 1,
//     la: '帐号',
//     gid: '游戏ID',
//     ext: 1, // 浮层数据
//     e1: '功能类型',
//     e2: '功能名称'
// }
export const statsRequest = function(config) {
  let img = new Image(),
    statsUrl = "//gcollectdata.37games.com/ps.gif?",
    param = "";
  let createParams = (config) => {
    for (var i in config) {
      param += i + "=" + config[i] + "&";
    }
  };
  Object.prototype.toString.call(config) !== "[object Object]" ? console.log("Error! statsReq config is not a object! The value is " + config) : createParams(config);
  img.src = statsUrl + param;
};

export const SOUTHEST_ASIA_MODE = 1;
export const WESTTERN_MODE = 2;

const MAIN_HOST = globalConfig.getMainHost();
export const EXCHANGE_URL = `//gevents.37games.com/globalexchange/indexm.html`;
export const FEEKBACK_URL = `//gabres.${MAIN_HOST}/platform/support.html#/mylist`;
export const SERVICE_TERM_URL = `//gpassport.${MAIN_HOST}/center/servicePrivicy/service`;
export const PRIVICY_TERM_URL = `//gpassport.${MAIN_HOST}/center/servicePrivicy/privicy`;
export const STORE_PAGE_BASE_URL = `//gabres.${MAIN_HOST}/platform/store.html`;
export const RES_HOST = `//gabres.${MAIN_HOST}/`;

export const renderGoogleRecaptcha = function(id, key) {
  if (window.grecaptcha.render) {
    window.grecaptcha.render(id, {
      sitekey: key,
      callback: "onSubmit",
    });
  } else {
    window.recaptchaOnload = () => {
      window.grecaptcha.render(id, {
        sitekey: key,
        callback: "onSubmit",
      });
    };
  }
};

export const submitGoogleRecaptcha = function(callback) {
  window.onSubmit = (token) => {
    grecaptcha.reset();
    callback && callback instanceof Function ? callback(token) : "";
  };
};

/**
 * 检测数字是否越界，如果越界给出提示
 * @param {*number} num 输入数
 */
let _boundaryCheckingState = true
const checkBoundary = num => {
  if (_boundaryCheckingState) {
    if (num > Number.MAX_SAFE_INTEGER || num < Number.MIN_SAFE_INTEGER) {
      console.warn(
        `${num} is beyond boundary when transfer to integer, the results may not be accurate`
      );
    }
  }
};

const digitLength = (num) => {
  const eSplit = num.toString().split(/[eE]/)
  const len = (eSplit[0].split('.')[1] || '').length - +(eSplit[1] || 0)
  return len > 0 ? len : 0
}

/**
 * 把小数转成整数，支持科学计数法。如果是小数则放大成整数
 * @param {*number} num 输入数
 */
const float2Fixed = num => {
  if (num.toString().indexOf('e') === -1) {
    return Number(num.toString().replace('.', ''));
  }
  const dLen = digitLength(num);
  return dLen > 0 ? strip(Number(num) * Math.pow(10, dLen)) : Number(num);
};

/**
 * 迭代操作
 */
const iteratorOperation = (arr, operation) => {
  const [num1, num2, ...others] = arr;
  let res = operation(num1, num2);

  others.forEach(num => {
    res = operation(res, num);
  });

  return res;
};

/**
 * 精确乘法
 */
export const times = (...nums) => {
  if (nums.length > 2) {
    return iteratorOperation(nums, times);
  }

  const [num1, num2] = nums;
  const num1Changed = float2Fixed(num1);
  const num2Changed = float2Fixed(num2);
  const baseNum = digitLength(num1) + digitLength(num2);
  const leftValue = num1Changed * num2Changed;

  checkBoundary(leftValue);

  return leftValue / Math.pow(10, baseNum);
};

/**
 * 精确减法
 */
export const minus = (...nums) => {
  if (nums.length > 2) {
    return iteratorOperation(nums, minus);
  }

  const [num1, num2] = nums;
  const baseNum = Math.pow(10, Math.max(digitLength(num1), digitLength(num2)));
  return (times(num1, baseNum) - times(num2, baseNum)) / baseNum;
};

/**
 *  判断是否是函数
 * @param {*} obj 要判断的对象
 * @returns 
 */
export const isFn = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Function]';
}

/**
 * 判断两个window.location.origin是否是同一个主域
 * @param {*} h1 域名1
 * @param {*} h2 域名2
 * @returns 
 */
export const judgeIsSameMainHost = (h1, h2) => {
  let h1MainHostMatch = h1.match(/.\w*.\w*$/);
  let h2MainHostMatch = h2.match(/.\w*.\w*$/);
  if (
    h1MainHostMatch &&
    h2MainHostMatch &&
    h1MainHostMatch[0] &&
    h2MainHostMatch[0]
  ) {
    return h1MainHostMatch[0] == h2MainHostMatch[0];
  } else {
    return false;
  }
}
